import { useParams } from 'react-router';
import { useNavigate } from 'react-router-dom';

import { useLearningJourneyBreadcrumbs } from '@/store/v2/journeys/useLearningJourneyBreadcrumbs';
import { Button } from '@/ui/Button';
import { slugify } from '@/utils/misc';
import { ROUTE_PATH } from '@/constants/routePaths';

export const BackToJourney = (): JSX.Element | null => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const parsedLearningId = id ? parseInt(id) : NaN;

  const parentJourney = useLearningJourneyBreadcrumbs({
    id: parsedLearningId,
  });

  const handleClick = () => {
    if (parentJourney?.parentSectionId) {
      navigate(
        `${ROUTE_PATH.JOURNEY_BASE}/${parentJourney?.journeyId}/${slugify(parentJourney?.journeyTitle)}/section/${
          parentJourney?.parentSectionId
        }`,
      );
    } else {
      navigate(`${ROUTE_PATH.JOURNEY_BASE}/${parentJourney?.journeyId}/${slugify(parentJourney?.journeyTitle)}`);
    }
  };

  return parentJourney?.journeyId && parentJourney?.journeyTitle ? (
    <Button variant="ghost" onClick={handleClick} icon="long-arrow-alt-left">
      Back to journey
    </Button>
  ) : null;
};
